import { BACKEND_URL } from '@konova/config';
import { InfoBox } from '@konova/ui/info-box';
import { useMemo } from 'react';

export const EnvBanner = () => {
  const showBanner = useMemo(() => {
    if (!URL.canParse(BACKEND_URL)) {
      return false;
    }
    const url = new URL(BACKEND_URL);
    return (url.hostname !== window.location.hostname);
  }, [BACKEND_URL]);

  if (!showBanner) {
    return null;
  }

  return <InfoBox color='warning'>
    Using {BACKEND_URL}
  </InfoBox>;
};